export default {"src":"/_next/static/media/Aortic Aneurysms.941337b6.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};